import React from 'react';
import { Link } from 'react-router-dom';
import { Users, Calendar, Settings, Bot, TrendingUp, Shield, Zap } from 'lucide-react';

const Features = () => {
  const features = [
    {
      title: 'Unisales-CRM',
      description: 'Gira os seus clientes com eficiência e precisão. Acompanhe interações, histórico de vendas e personalize comunicações para aumentar a fidelização e vendas.',
      icon: Users,
      color: 'from-blue-500 to-blue-600',
      bgColor: 'bg-blue-50',
      path: '/crm'
    },
    {
      title: 'Unisales-Eventos',
      description: 'Organize eventos perfeitamente com ferramentas avançadas. Gira inscrições, agendas, pagamentos e feedback em tempo real para eventos memoráveis.',
      icon: Calendar,
      color: 'from-green-500 to-green-600',
      bgColor: 'bg-green-50',
      path: '/eventos'
    },
    {
      title: 'Unisales-ERP',
      description: 'Integre todos os processos empresariais numa plataforma unificada. Controle inventário, finanças, RH e operações para otimizar a produtividade e reduzir custos.',
      icon: Settings,
      color: 'from-purple-500 to-purple-600',
      bgColor: 'bg-purple-50',
      path: '/erp'
    },
    {
      title: 'Unisales IA',
      description: 'Inteligência artificial para otimizar decisões e automatizar processos. Use IA para previsões, chatbots e análise de dados avançada.',
      icon: Bot,
      color: 'from-orange-500 to-orange-600',
      bgColor: 'bg-orange-50',
      path: '/ia'
    }
  ];

  const stats = [
    { icon: TrendingUp, value: '300%', label: 'Aumento em Produtividade' },
    { icon: Shield, value: '99.9%', label: 'Uptime Garantido' },
    { icon: Zap, value: '< 2s', label: 'Tempo de Resposta' }
  ];

  return (
    <section id="features" data-aos="fade-up" className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">Nossos Produtos Inovadores</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Descubra como nossas soluções Unisales podem transformar seu negócio com tecnologia de ponta e suporte especializado.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <div
                key={index}
                className={`${feature.bgColor} p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 group`}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className={`w-16 h-16 bg-gradient-to-r ${feature.color} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <IconComponent className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold mb-3 text-gray-800">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
                <div className="mt-4">
                  <Link to={feature.path} className="inline-block bg-white px-3 py-1 rounded-full text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-100 transition duration-300">
                    Saiba mais →
                  </Link>
                </div>
              </div>
            );
          })}
        </div>

        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
          <h3 className="text-3xl font-bold text-center mb-8">Resultados Comprovados</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {stats.map((stat, index) => {
              const StatIcon = stat.icon;
              return (
                <div key={index} className="text-center group">
                  <div className="w-20 h-20 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                    <StatIcon className="w-10 h-10 text-white" />
                  </div>
                  <div className="text-4xl font-bold text-gray-800 mb-2">{stat.value}</div>
                  <p className="text-gray-600 font-medium">{stat.label}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
